import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ShippingTypeSettingsComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="ImmediateDelivery"
                            name="ImmediateDelivery"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingTypeSettings.ImmediateDelivery',
                                    selectLogisticsSettings?.ShippingTypeSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingTypeSettings?.ImmediateDelivery}
                        />
                        <InputContainer
                            label="SameDayDelivery"
                            name="SameDayDelivery"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingTypeSettings.SameDayDelivery',
                                    selectLogisticsSettings?.ShippingTypeSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingTypeSettings?.SameDayDelivery}
                        />

                        <InputContainer
                            label="NextDayDelivery"
                            name="NextDayDelivery"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingTypeSettings.NextDayDelivery',
                                    selectLogisticsSettings?.ShippingTypeSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingTypeSettings?.NextDayDelivery}
                        />
                    </div>
                }
                expandedPanel="ShippingType Settings"
                headerTitle="ShippingType Settings"
            />
        </>
    )
}
export default ShippingTypeSettingsComponent;
